/* Zwei Zeichen als Zeichnung statt als Bildzeichen.
 *
 * Ein Emoji bringt seine eigene Farbe mit: 🔒 ist gelb und ⚙ je nach
 * Schriftart mal Umriss, mal Fläche. In einer Oberfläche mit zwei Themen
 * ist das in mindestens einem der beiden falsch. Diese hier erben die
 * Schriftfarbe ihres Knopfes.
 */

export function Schloss({ klasse = 'schloss' }: { klasse?: string }) {
  return (
    <svg className={klasse} viewBox="0 0 11 13" fill="none"
         stroke="currentColor" strokeWidth="1.3" aria-hidden="true">
      <path d="M3 5.4V3.6a2.5 2.5 0 0 1 5 0v1.8" strokeLinecap="round" />
      <rect x="1.2" y="5.4" width="8.6" height="6.6" rx="1.6"
            fill="currentColor" stroke="none" />
    </svg>
  )
}

export function Zahnrad() {
  return (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor"
         strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
         aria-hidden="true">
      <circle cx="10" cy="10" r="2.6" />
      <path d="M10 1.8v2.1M10 16.1v2.1M15.8 4.2l-1.5 1.5M5.7 14.3l-1.5 1.5
               M18.2 10h-2.1M3.9 10H1.8M15.8 15.8l-1.5-1.5M5.7 5.7 4.2 4.2" />
    </svg>
  )
}
